module.exports = __webpack_public_path__ + "img/hair_color_blue.84dcbb2.svg";